import { render, staticRenderFns } from "./MobileOrientation.vue?vue&type=template&id=4f1cf8e0&"
import script from "./MobileOrientation.vue?vue&type=script&lang=js&"
export * from "./MobileOrientation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports